export default __webpack_public_path__ + "static/media/TAMES Simple Logo.8145f22f.png";